Vue.component('client-partner', {
    delimiters: ['[[', ']]'],
    template: `
        <div>
            <section class="vc_row">
                <div class="container">
                    <div class="row">

                        <div  class="carousel-container carousel-shadow-active carousel-nav-left carousel-nav-md carousel-dots-style1">
                            <div class="carousel-items row" data-lqd-flickity='{"wrapAround": true}'>

                                <div class="lqd-column w-20 text-center px-2">
                                    <figure>
                                        <img src="./assets/demo/clients/client-8.png" alt="Client">
                                    </figure>
                                </div><!-- /.lqd-column w-20 text-center px-2 -->

                                <div class="lqd-column w-20 text-center px-2">
                                    <figure>
                                        <img src="./assets/demo/clients/client-9.png" alt="Client">
                                    </figure>
                                </div><!-- /.lqd-column w-20 text-center px-2 -->

                                <div class="lqd-column w-20 text-center px-2">
                                    <figure>
                                        <img src="./assets/demo/clients/client-10.png" alt="Client">
                                    </figure>
                                </div><!-- /.lqd-column w-20 text-center px-2 -->

                                <div class="lqd-column w-20 text-center px-2">
                                    <figure>
                                        <img src="./assets/demo/clients/client-11.png" alt="Client">
                                    </figure>
                                </div><!-- /.lqd-column w-20 text-center px-2 -->

                                <div class="lqd-column w-20 text-center px-2">
                                    <figure>
                                        <img src="./assets/demo/clients/client-12.png" alt="Client">
                                    </figure>
                                </div><!-- /.lqd-column w-20 text-center px-2 -->

                                <div class="lqd-column w-20 text-center px-2">
                                    <figure>
                                        <img src="./assets/demo/clients/client-10.png" alt="Client">
                                    </figure>
                                </div><!-- /.lqd-column w-20 text-center px-2 -->

                                <div class="lqd-column w-20 text-center px-2">
                                    <figure>
                                        <img src="./assets/demo/clients/client-8.png" alt="Client">
                                    </figure>
                                </div><!-- /.lqd-column w-20 text-center px-2 -->

                                <div class="lqd-column w-20 text-center px-2">
                                    <figure>
                                        <img src="./assets/demo/clients/client-9.png" alt="Client">
                                    </figure>
                                </div><!-- /.lqd-column w-20 text-center px-2 -->

                            </div><!-- /.carousel-items -->
                        </div><!-- /.carousel-container -->

                    </div><!-- /.row -->
                </div><!-- /.container -->
            </section><!-- /.vc_row -->
        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
    },
    data: function () {
        return {
            menuType: 1,
        }
    },
    mounted(){

    },
    methods: {

    },
});